var mobileCheckResult = null;
function mobileCheck() {
    if (mobileCheckResult) {
        return mobileCheckResult;
    }

    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    mobileCheckResult = check;

    return check;
}

var industries = [
    {
        'name': 'Ambassader & Internationella Org.',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ],
        'article': {
            'text': 'Många småföretagare skulle behöva ett smartare kontor',
            'image': '/images/examples/home-industries-article-bubble.jpg',
            'url': '/about_csr.html'
        }
    },
    {
        'name': 'Avlopp, Avfall, El & Vatten',
        'services': [
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Bank, Finans & Försäkring',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
        ]
    },
    {
        'name': 'Bemanning & Arbetsförmedling',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Bransch-, Arbetsgivar- & Yrkesorg.',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
        ]
    },
    {
        'name': 'Bygg-, Design- & Inredningsverksamhet',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Data, It & Telekommunikation',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Detaljhandel',
        'services': [
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Fastighetsverksamhet',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
        ]
    },
    {
        'name': 'Företagstjänster',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Hotell & Restaurang',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
        ]
    },
    {
        'name': 'Hår & Skönhetsvård',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Hälsa & Sjukvård',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Jordbruk, Skogsbruk, Jakt & Fiske',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
        ]
    },
    {
        'name': 'Juridik, Ekonomi & Konsulttjänster',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Kultur, Nöje & Fritid',
        'services': [
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Livsmedelsframställning',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Media',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Motorfordonshandel',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Offentlig Förvaltning & Samhälle',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Partihandel',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Reklam, Pr & Marknadsundersökning',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
        ]
    },
    {
        'name': 'Reparation & Installation',
        'services': [
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Resebyrå & Turism',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Teknisk Konsultverksamhet',
        'services': [
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Tillverkning & Industri',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Transport & Magasinering',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Utbildning, Forskning & Utveckling',
        'services': [
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Uthyrning & Leasing',
        'services': [
            { id: 'facility', icon: '/images/icons/facility.svg', url: '/product.html', text: 'Facility Services' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
    {
        'name': 'Övriga Konsumenttjänster',
        'services': [
            { id: 'it', icon: '/images/icons/it.svg', url: '/product.html', text: 'IT-Tjänster' },
            { id: 'fika', icon: '/images/icons/fika.svg', url: '/product.html', text: 'Fikalösningar' },
            { id: 'document', icon: '/images/icons/document.svg', url: '/product.html' },
            { id: 'phone', icon: '/images/icons/phone.svg', url: '/product.html', text: 'Telefoni' },
            { id: 'communication', icon: '/images/icons/communication.svg', url: '/product.html', text: 'Konferens' },
        ]
    },
];

var nodes = [];

var productsSearch = new Vue({
    el: $('.home-industries-section')[0],
    data: {
        query: '',
        industries: [],
        open: false,
        selected: null
    },
    computed: {
        industryList: function () {
            if (this.query.length > 0) {
                var self = this;

                var industries = this.industries.filter(function (industry) {
                    return industry.name.toLowerCase().indexOf(self.query.toLowerCase()) > -1;
                });

                if (industries.length > 0) {
                    this.open = true;
                }

                return industries;
            }

            return this.industries;
        },
        showIndustries: function () {
            return this.open;
        }
    },
    methods: {
        fetchIndustries: function () {
            var self = this;
            setTimeout(function () {
                self.industries = industries;
            }, 1000);
        },

        selectIndustry: function (industry) {
            this.selected = industry;
            this.open = false;
        },

        resetIndustry: function () {
            this.selected = null;
        },
        start: function() {
            // var link = this.svg.selectAll(".link");
            var node = this.svg.selectAll(".node");

            var drag = this.force.drag();

            // link = link.data(this.force.links(), function(d) { return d.source.id + "-" + d.target.id; });
            // link.enter().insert("line")
            //     .attr("class", "link");
            // link.exit().remove();

            node = node.data(this.force.nodes(), function(d) {
                return d.id;
            });

            var nodeEnter = node.enter()
                .append("g")
                .attr("class", function (d) { return 'node ' + (d.fixed ? 'fixed' : ''); })
                //.call(drag)
                .on('click', function (d) {
                    document.location.href = d.url;
                });

            var self = this;

            nodeEnter.each(function (d) {
                var item = d3.select(this);

                if (d.type != 'article') {
                    item.append("circle")
                        .attr("r", function (d) { return d.radius; })
                        .attr("fill", '#ff0000');
                }

                if (d.type == 'article') {
                    item.append('clipPath')
                        .attr('clipPathUnits', 'objectBoundingBox')
                        .attr('id', 'circle-mask')
                        .append('circle')
                        .attr('cx', 0.5)
                        .attr('cy', 0.5)
                        .attr("r", function(d) { return 0.5; });

                    item.append('image')
                        .attr("xlink:href", function (d) {
                            return d.background;
                        })
                        .attr('x', function (d) { return -d.radius; })
                        .attr('y', function (d) { return -d.radius; })
                        .attr('width', function (d) { return d.radius * 2; })
                        .attr('height', function (d) { return d.radius * 2; })
                        .attr('preserveAspectRatio', 'xMinYMin slice')
                        .attr('clip-path', 'url(#circle-mask)');
                }

                item.append('text')
                    .attr('text-anchor', 'middle')
                    .attr('style', function (d) {
                        if (d.type == 'article') {
                            return 'font-weight: normal; font-size: 1rem;';
                        }
                        else {
                            return 'font-weight: 500; font-size: 0.6875rem; text-transform: uppercase;';
                        }
                    })
                    .attr('fill', '#ffffff')
                    .attr('dy', function (d) {
                        if (d.type == 'article') {
                            return 0;
                        }
                        else {
                            return 40;
                        }
                    })
                    .text(function (d) {
                        return d.text;
                    })
                    .call(self.wrap, 250, d.type == 'article');

                if (d.type != 'article') {
                    item.append('image')
                        .attr("xlink:href", function (d) {
                            return d.icon;
                        })
                        .attr('x', -37.5)
                        .attr('y', -52.5)
                        .attr('width', 75)
                        .attr('height', 75);
                }
            });

            node.exit().remove();

            this.force.start();

        },
        tick: function() {
            // var link = this.svg.selectAll(".link");
            var node = this.svg.selectAll(".node");

            // link.attr("x1", function(d) { return d.source.x; })
            //     .attr("y1", function(d) { return d.source.y; })
            //     .attr("x2", function(d) { return d.target.x; })
            //     .attr("y2", function(d) { return d.target.y; });

            // For circle
            // node.attr("cx", function(d) { return d.x = Math.max(d.radius+20, Math.min(width - d.radius-20, d.x)); })
            //     .attr("cy", function(d) { return d.y = Math.max(d.radius+20, Math.min(height - d.radius-20, d.y)); });

            var width = this.width;
            var height = this.height;

            node.attr('transform', function (d) {
                var ed = 20;
                var multiplier = 1;

                if (mobileCheck()) {
                    multiplier = 0.7;
                }

                var x = Math.max(d.radius*multiplier+ed, Math.min(width - d.radius*multiplier-ed, d.x));
                var y = Math.max(d.radius*multiplier+ed, Math.min(height - d.radius*multiplier-ed, d.y));

                var value = 'translate(' + x + ',' + y + ')';

                if (mobileCheck()) {
                    value += ' scale(0.7)';
                }

                return value;
            });
        },
        wrap: function (text, width, isArticle) {
          if (!isArticle) {
            return text.text();
          }

          text.each(function() {
            var text = d3.select(this),
                words = text.text().split(/\s+/).reverse(),
                word,
                line = [],
                lineNumber = 0,
                lineHeight = 1.3, // ems
                y = text.attr("y"),
                dy = parseFloat(text.attr("dy")),
                tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
            while ((word = words.pop())) {
              line.push(word);
              tspan.text(line.join(" "));
              if (tspan.node().getComputedTextLength() > width) {
                line.pop();
                tspan.text(line.join(" "));
                line = [word];
                tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", lineHeight + "em").text(word);
                ++lineNumber;
                text.attr('y', -(lineNumber)/2 + 'em');
              }
            }

            tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", "3em").attr('style', 'font-size: 0.8125rem; font-weight: 500; text-transform: uppercase;').text('Läs mer');
          });
        },
        createNodes: function (selection) {
            var services = selection ? selection.services : null;
            var article = selection ? selection.article : null;

            if (!selection) {
                var dx = 250;
                var dy = 100;

                if (mobileCheck()) {
                    dx = 50;
                    dy = 50;
                }

                services = [
                    { radius: 80, x: dx, y: dy, id: 'it', type: 'service', text: 'IT-Tjänster', icon: '/images/icons/it.svg', url: '/product.html' },
                    { radius: 80, x: dx, y: this.height-dy, id: 'fika', type: 'service', text: 'Fikalösningar', icon: '/images/icons/fika.svg', url: '/product.html' },
                    { radius: 80, x: this.width-dx, y: dy, id: 'communication', type: 'service', text: 'Konferens', icon: '/images/icons/communication.svg', url: '/product.html' },
                    { radius: 80, x: this.width-dx, y: this.height-dy, id: 'document', type: 'service', text: 'Dokumenthantering', icon: '/images/icons/document.svg', url: '/product.html' },
                    { radius: 80, x: this.width/2, y: dy, id: 'phone', type: 'service', text: 'Telefoni', icon: '/images/icons/phone.svg', url: '/product.html' },
                    { radius: 80, x: this.width/2, y: this.height-dy, id: 'facility', type: 'service', text: 'Facility Services', icon: '/images/icons/facility.svg', url: '/product.html' },
                    //{radius: 140, id: 7, type:'article', text: 'Många småföretagare skulle behöva ett smartare kontor. Många småföretagare skulle behöva ett smartare kontor.', background: '/images/examples/home-industries-article-bubble.jpg', link: '/about_csr.html' },
                ];
            }

            if (mobileCheck()) {
                services = services.slice(0, 4);
            }

            // Always need the center "pusher"
            services.push({x: this.width/2, y: this.height/2, radius: 40, fixed: true, charge: -500, id: 'center'});

            // Remove elements
            for (var i = nodes.length-1; i >= 0; i--) {

                var inArray = false;
                for (var j = 0; j < services.length; j++) {
                    var service = services[j];

                    if (service.id == nodes[i].id) {
                        inArray = true;
                    }
                }

                if (!inArray) {
                    nodes.splice(i, 1);
                }
            }

            // Add elements
            for (var serviceLoop = 0; serviceLoop < services.length; serviceLoop++) {
              var currentService = services[serviceLoop];

                var serviceInArray = false;
                for (var nodesLoop = 0; nodesLoop < nodes.length; nodesLoop++) {
                  if (nodes[nodesLoop].id == currentService.id) {
                    serviceInArray = true;
                    }
                }

                if (!serviceInArray) {
                    nodes.push({
                        radius: 80,
                        type: 'service',
                        text: currentService.text,
                        icon: currentService.icon,
                        url: currentService.url,
                        id: currentService.id,
                        fixed: currentService.fixed,
                        x: currentService.x,
                        y: currentService.y
                    });
                }
            }

            // Push article
            if (article && !mobileCheck()) {
                nodes.push({
                    radius: 140,
                    id: 'article',
                    type:'article',
                    text: article.text,
                    background: article.image,
                    url: article.url
                });
            }
        }
    },
    watch: {
        'selected': function (val, oldval) {
            this.createNodes(val);
            this.start();
        }
    },
    ready: function () {
        this.fetchIndustries();

        this.width = $('.background-circles').width();
        this.height = $('.background-circles').height();

        this.createNodes(null);

        this.force = d3.layout.force()
            //.links(links)
            .nodes(nodes)
            .size([this.width, this.height])
            .charge(function (d) {
                return d.charge || -d.radius * 10 * (mobileCheck() ? 0.75 : 1);
            })
            .linkDistance(function (d) {
                return Math.min(this.width, this.height)/1.4;
            })
            .linkStrength(0.5)
            .friction(0.9)
            .gravity(0.015)
            .on("tick", this.tick);

        this.svg = d3.select(".background-circles").append("svg")
            .attr("width", this.width)
            .attr("height", this.height);

        var self = this;

//        setTimeout(function () {
            self.start();
//        }, 100);

        // $(window).on('resize', function () {
        //     var width = $('.background-circles').width();
        //     var height = $('.background-circles').height();
        //     self.force.size([width, height]);
        //     self.force.start();
        // });
    }
});
